<template>
    <v-menu v-model="menu" :close-on-content-click="false">
        <template #activator="{ on }">
            <v-btn v-on="on" color="primary">
                <v-icon left>mdi-calendar</v-icon>

                {{ dateRangeString }}
            </v-btn>
        </template>

        <v-date-picker
            :value="value"
            @input="$emit('input', $event.sort())"
            range
            :max="today"
            no-title
            scrollable
        ></v-date-picker>
    </v-menu>
</template>

<script>
import moment from '@/plugins/moment'

export default {
    props: {
        value: {
            type: Array,
        }
    },

    data() {
        return {
            menu: false,
        }
    },

    computed: {
        today() {
            return moment().format('YYYY-MM-DD')
        },

        dateRangeString() {
            if (this.value) {
                return `${moment(this.value[0]).format('D MMM YYYY')} - ${moment(this.value[1]).format('D MMM YYYY')}`
            }

            return null
        }
    },

    watch: {
        value(to) {
            if (to.length === 2) {
                this.menu = false
            }
        }
    },
}
</script>
